import {makeRequest, makeRequestPut, makeRequestGet} from '../../Services/API';

export function getLayouts(lang = 'POR') {
    return makeRequestGet(`/backend/proposta/getLayouts/${lang}`);
}
export function getTextosDespedida(lang = 'POR') {
    return makeRequestGet(`/backend/proposta/getTextosDespedida/${lang}`);
}
export function getTextosIntro(lang = 'POR') {
    return makeRequestGet(`/backend/proposta/getTextosIntro/${lang}`);
}
export function getLocaisEntrega(lang = 'POR') {
    return makeRequestGet(`/backend/proposta/getLocaisEntrega/${lang}`);
}
export function getCondicoesPagamento(lang = 'POR') {
    return makeRequestGet(`/backend/proposta/getCondicoesPagamento/${lang}`);
}

export function getGarantias(lang = 'POR') {
    return makeRequestGet(`/backend/proposta/getGarantias/${lang}`);
}

export function getGarantiasPower(lang = 'POR') {
    return makeRequestGet(`/backend/proposta/getGarantiasPower/${lang}`);
}

export function getGarantiasMotor(lang = 'POR') {
    return makeRequestGet(`/backend/proposta/getGarantiasMotor/${lang}`);
}

export function getEstadosAprovacao(lang = 'POR') {
    return makeRequestGet(`/backend/proposta/getEstadosAprovacao/${lang}`);
}

export function getTemplatesEmailOrcamento(lang = 'POR') {
    return makeRequestGet(`/backend/proposta/getTemplatesEmailOrcamento/${lang}`);
}
export function getEmailOrcamento(lang = 'POR', idProposta) {
    const encodedIdProposta = encodeURIComponent(idProposta);
    return makeRequestGet(`/backend/proposta/geEmailsOrcamento/${encodedIdProposta}/${lang}`);
}
